/*
 * Footer Messages
 *
 * This contains all the text for the footer component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.footer';

export default defineMessages({
  aboutUs: {
    id: `${scope}.aboutUs`,
    defaultMessage: 'Giới thiệu Kamereo',
  },
  support: {
    id: `${scope}.support`,
    defaultMessage: 'Hỗ trợ',
  },
  careers: {
    id: `${scope}.careers`,
    defaultMessage: 'Tuyển Dụng',
  },
  downloadOn: {
    id: `${scope}.downloadOn`,
    defaultMessage: 'Tải về trên',
  },
  getItOn: {
    id: `${scope}.getItOn`,
    defaultMessage: 'Tải về trên',
  },
  faqs: {
    id: `${scope}.faqs`,
    defaultMessage: 'FAQs',
  },
  home: {
    id: `${scope}.home`,
    defaultMessage: 'Trang Chủ',
  },
  followUs: {
    id: `${scope}.followUs`,
    defaultMessage: 'Kết nối với chúng tôi',
  },
  payment: {
    id: `${scope}.payment`,
    defaultMessage: 'Phương Thức Thanh Toán',
  },
  delivery: {
    id: `${scope}.delivery`,
    defaultMessage: 'Chính Sách Giao Hàng',
  },
  exchange: {
    id: `${scope}.exchange`,
    defaultMessage: 'Chính Sách Đổi Trả',
  },
  allRightReserved: {
    id: `${scope}.allRightReserved`,
    defaultMessage: '© {currentYear} Kamereo. All rights reserved.',
  },
  address: {
    id: `${scope}.address`,
    defaultMessage:
      'Địa chỉ: F05&F06A Tầng 1-Tòa nhà The Manor Officetel, 89 Nguyễn Hữu Cảnh, P. Thạnh Mỹ Tây, Tp. Hồ Chí Minh, Việt Nam',
  },
  businessRegistrationCertificate: {
    id: `${scope}.businessRegistrationCertificate`,
    defaultMessage:
      'Giấy CNĐKDN: 0315000500 - Ngày cấp 19/04/2018 - Cơ quan cấp: Phòng Đăng ký kinh doanh – Sở kế hoạch và Đầu tư TP.HCM',
  },
  wholesaleLiquorLicense: {
    id: `${scope}.wholesaleLiquorLicense`,
    defaultMessage:
      'Giấy phép bán buôn rượu số 227/GP-SCT - Ngày cấp: 15/06/2023 - Cơ quan cấp: Sở Công Thương - UBND TPHCM',
  },
  kamereoCo: {
    id: `${scope}.kamereoCo`,
    defaultMessage: 'CÔNG TY TNHH KAMEREO.',
  },
  certifications: {
    id: `${scope}.certifications`,
    defaultMessage: 'Chứng Nhận',
  },
  press: {
    id: `${scope}.press`,
    defaultMessage: 'Báo Chí',
  },
  phoneNumber: {
    id: `${scope}.phoneNumber`,
    defaultMessage: 'SĐT:',
  },
  firstFooterDescription: {
    id: `${scope}.firstFooterDescription`,
    defaultMessage: 'Với hơn 2000 sản phẩm chất lượng từ',
  },
  lastFooterDescription: {
    id: `${scope}.lastFooterDescription`,
    defaultMessage: ', giá cả bình ổn, kèm theo dịch vụ giao hàng chuyên nghiệp, hỗ trợ xuất hóa đơn nhanh chóng.',
  },
  freshVegetables: {
    id: `${scope}.freshVegetables`,
    defaultMessage: 'rau củ quả tươi',
  },
  kitchenUtensils: {
    id: `${scope}.kitchenUtensils`,
    defaultMessage: 'vật dụng nhà bếp',
  },
  to: {
    id: `${scope}.to`,
    defaultMessage: 'đến',
  },
  commitFresh: {
    id: `${scope}.commitFresh`,
    defaultMessage: 'Cam Kết Tươi Mới',
  },
  news: {
    id: `${scope}.news`,
    defaultMessage: 'Tin Tức',
  },
  businessTips: {
    id: `${scope}.businessTips`,
    defaultMessage: 'Kinh Doanh F&B',
  },
  coreValues: {
    id: `${scope}.coreValues`,
    defaultMessage: 'Giá Trị Cốt Lõi',
  },
  consultingServices: {
    id: `${scope}.consultingServices`,
    defaultMessage: 'Tư vấn dịch vụ',
  },
  reflectingQuality: {
    id: `${scope}.reflectingQuality`,
    defaultMessage: 'Phản ánh chất lượng',
  },
  distributionLocation: {
    id: `${scope}.distribution`,
    defaultMessage: 'Hệ Thống Phân Phối',
  },
  keepInTouch: {
    id: `${scope}.keepInTouch`,
    defaultMessage: 'Liên hệ Kamereo',
  },
  trustedBrands: {
    id: `${scope}.trustedBrands`,
    defaultMessage: 'Thương hiệu nổi bật',
  },
  trendingSearch: {
    id: `${scope}.trendingSearch`,
    defaultMessage: 'Tìm kiếm phổ biến',
  },
  customers: {
    id: `${scope}.customers`,
    defaultMessage: 'Khách hàng',
  },
  restaurant: {
    id: `${scope}.restaurant`,
    defaultMessage: 'Nhà hàng',
  },
  barClub: {
    id: `${scope}.barClub`,
    defaultMessage: 'Bar - Club',
  },
  coffee: {
    id: `${scope}.coffee`,
    defaultMessage: 'Cà phê',
  },
  storeSuperMarket: {
    id: `${scope}.storeSuperMarket`,
    defaultMessage: 'Cửa hàng/siêu thị/khác',
  },
  foodService: {
    id: `${scope}.foodService`,
    defaultMessage: 'Dịch vụ ăn uống',
  },
  eatery: {
    id: `${scope}.eatery`,
    defaultMessage: 'Quán ăn',
  },
  branches: {
    id: `${scope}.branches`,
    defaultMessage: 'Chi nhánh',
  },
  theNorth: {
    id: `${scope}.theNorth`,
    defaultMessage: 'Miền Bắc',
  },
  theSouth: {
    id: `${scope}.theSouth`,
    defaultMessage: 'Miền Nam',
  },
  mediaCoverage: {
    id: `${scope}.mediaCoverage`,
    defaultMessage: 'Bài viết về chúng tôi',
  },
  tagline: {
    id: `${scope}.tagline`,
    defaultMessage: 'Nhà cung ứng toàn diện dành cho doanh nghiệp F&B tại Việt Nam',
  },
  products: {
    id: `${scope}.products`,
    defaultMessage: 'Sản phẩm',
  },
  shoppingNow: {
    id: `${scope}.shoppingNow`,
    defaultMessage: 'Mua hàng',
  },
  farmToBusiness: {
    id: `${scope}.farmToBusiness`,
    defaultMessage: 'Tươi từ nông trại',
  },
  kamereoFresh: {
    id: `${scope}.kamereoFresh`,
    defaultMessage: 'Kamereo Ngon',
  },
  kamereoEssential: {
    id: `${scope}.kamereoEssential`,
    defaultMessage: 'Kamereo Tiện Dụng',
  },
  resources: {
    id: `${scope}.resources`,
    defaultMessage: 'Tài nguyên',
  },
  company: {
    id: `${scope}.company`,
    defaultMessage: 'Công ty',
  },
  whyKamereo: {
    id: `${scope}.whyKamereo`,
    defaultMessage: 'Giới thiệu Kamereo',
  },
  supportSection: {
    id: `${scope}.supportSection`,
    defaultMessage: 'Hỗ trợ',
  },
  phoneContact: {
    id: `${scope}.phoneContact`,
    defaultMessage: 'Số điện thoại: 0812 46 37 27',
  },
  addressLabel: {
    id: `${scope}.addressLabel`,
    defaultMessage: 'Địa chỉ:',
  },
});
